<div class="user-input-form">
  <ng-container *ngFor="let input of inputs; let i = index">
    <mat-form-field
      appearance="outline"
      style="margin-bottom: 5px; width: 100%"
    >
      <input
        class="user-input-form-text-field"
        matInput
        [(ngModel)]="input.value"
        [name]="'contact-field-' + i"
        [attr.id]="'contact-field-' + i"
        (ngModelChange)="onValueChange(input.type, $event)"
        [placeholder]="input.text[currentLang]"
        [attr.aria-label]="input.text[currentLang] || input.type"
      />
    </mat-form-field>
  </ng-container>
</div>
